/* global globalThis */
import React, { memo } from "react";
import PropTypes from "prop-types";
import useStyles from "./styles";
import ContinueVideoDialog from "./ContinueVideoDialog";
import { Box, Typography } from "@material-ui/core";
import { VideoPlayer } from "../../../elements";

const parseVideoPlayerControls = (controls) => {
  if (controls === undefined || controls === null || controls === "false") {
    return false;
  }

  if (controls === "true") {
    return true;
  }

  if (typeof controls === "boolean") {
    return controls;
  }

  return false;
};

function VideoSelfLearning(props) {
  const { 
    playerRef,
    currentVideo,
    videoPlayback,
    setVideoPlayback,
    handleVideoPlayback,
    handleVideoOnReady,
    showPopup,
    closePopup,
    handleResume,
    handleStartFromBeginning,
    callProgressApi,
    videoPlayerControls,
    isVideoLoaded,
  } = props;

  const classes = useStyles();
  const dynamicVideoControl = parseVideoPlayerControls(videoPlayerControls);

    return (
    <Box className={classes.videoWrapper}>
            {/* Video Description */}
            <Box style={{width: '90%'}}>
        <Box className={classes.titleBox}>
          <Typography variant="h5" className={classes.videoTitle}>
            {currentVideo?.contentData?.title}
          </Typography>
        </Box>
        <Box className={classes.descriptionBox}>
          <Typography className="ck-content" component="p" dangerouslySetInnerHTML={{ __html: currentVideo?.contentData?.description }}></Typography>
        </Box>
      </Box>

      {currentVideo && <VideoPlayer
        type={currentVideo.type}
        url={currentVideo.videoUrl}
        controls={dynamicVideoControl}
        playing={videoPlayback}
        onReady={handleVideoOnReady}
        isVideoLoaded={isVideoLoaded}
        videoPlayerRef={playerRef}
        handlePlaying={handleVideoPlayback}
        onPause={() => {
          setVideoPlayback(false); 
          callProgressApi({})}}
        onEnded={() => callProgressApi({})}
      />}

      {isVideoLoaded && showPopup && (
        <ContinueVideoDialog
          showModal={showPopup}
          closeModal={closePopup}
          handleYes={handleResume}
          handleNo={handleStartFromBeginning}
        />
      )}
    </Box>
  );
}

VideoSelfLearning.propTypes = {
  playerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  currentVideo: PropTypes.shape({
    type: PropTypes.string,
    videoUrl: PropTypes.string,
    contentData: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
  }),
  videoPlayback: PropTypes.bool,
  setVideoPlayback: PropTypes.func,
  handleVideoPlayback: PropTypes.func,
  handleVideoOnReady: PropTypes.func,
  showPopup: PropTypes.bool,
  closePopup: PropTypes.func,
  handleResume: PropTypes.func,
  handleStartFromBeginning: PropTypes.func,
  callProgressApi: PropTypes.func,
  videoPlayerControls: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isVideoLoaded: PropTypes.bool,
};

export default memo(VideoSelfLearning);
